export interface ILiteralesResponse {
  createdAt: Date;
  id: number;
  updatedAt: Date;
  key: string;
  tipoLiteral: string;
  funcionalidad: Funcionalidad;
  tablaRelacion: TablaRelacion | null;
  columnaRelacion: ColumnaRelacion | null;
  elementoRelacion: null | string;
  literal_ES: string;
}

export interface ILiteral {
  key: string;
  literal_ES: string;
}

export enum ColumnaRelacion {
  Code = "code",
  InternalName = "internalName",
  NameItem = "nameItem",
}

export enum Funcionalidad {
  Cross = "cross",
  Flow = "flow",
  HealthQuestionnaire = "healthQuestionnaire",
  PriceComparator = "price-comparator",
  RequiredDocuments = "required_documents",
}

export enum TablaRelacion {
  LineaNegocio = "linea_negocio",
  PersonaType = "persona_type",
  Products = "products",
}
